import {
  DuplexMode,
  FrequencyRange,
  FronthaulType,
  LicenseStatus,
} from "@allbesmart/web-app-common";
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  ValidationErrors,
} from "@angular/forms";

export type LicenseConfigurationFormGroup = FormGroup<{
  configurationIsShown: FormControl<boolean | null>;
  status: FormControl<LicenseStatus | null>;
  startDate: FormControl<string | null>;
  endDate: FormControl<string | null>;
}>;

export type RedCapConfigurationFormGroup = FormGroup<{
  redCap: FormControl<boolean | null>;
  halfDuplexRedCapAllowedR17: FormControl<number | null>;
  cellBarredRedCap1RxR17: FormControl<number | null>;
  cellBarredRedCap2RxR17: FormControl<number | null>;
  intraFreqReselectionRedCapR17: FormControl<number | null>;
  t300: FormControl<number | null>;
  t301: FormControl<number | null>;
  t310: FormControl<number | null>;
  t311: FormControl<number | null>;
  n310: FormControl<number | null>;
  n311: FormControl<number | null>;
  t319: FormControl<number | null>;
}>;

export type Cn5gConfigurationFormGroup = FormGroup<{
  cn5gRemote: FormControl<boolean | null>;
  cn5gIp: FormControl<string | null>;
  cn5gInterfaceName: FormControl<string | null>;
  cn5gNextHop: FormControl<string | null>;
  cn5gAmfIp: FormControl<string | null>;
  cn5gUpfIp: FormControl<string | null>;
  cn5gSmfIp: FormControl<string | null>;
  cn5gAusfIp: FormControl<string | null>;
  cn5gUdmIp: FormControl<string | null>;
  cn5gUdrIp: FormControl<string | null>;
  cn5gNrfIp: FormControl<string | null>;
  cn5gNssfIp: FormControl<string | null>;
  cn5gNefIp: FormControl<string | null>;
  cn5gNwdafIp: FormControl<string | null>;
  cn5gLmfIp: FormControl<string | null>;
  cn5gPcfIp: FormControl<string | null>;
  cn5gUdsfIp: FormControl<string | null>;
  cn5gOpenSpeedTestIp: FormControl<string | null>;
  cn5gOaiExtDnIp: FormControl<string | null>;
  cn5gImsIp: FormControl<string | null>;
}>;

export type UeManagementFormGroup = FormGroup<{
  enabled: FormControl<boolean | null>;
  oaiUeMachineIds: FormArray<FormControl<string | null>>;
}>;

export type OfflineConfigurationFormGroup = FormGroup<{
  enabled: FormControl<boolean | null>;
}>;

export type UpdateDeploymentFormGroup = FormGroup<{
  name: FormControl<string | null>;
  description: FormControl<string | null>;
  domainAutoAssignment: FormControl<boolean | null>;
  licenseConfiguration: LicenseConfigurationFormGroup;
  offlineConfiguration: OfflineConfigurationFormGroup;
  fronthaulTypes: FormArray<FronthaulTypeFormGroup>;
  frequencyRanges: FormArray<FrequencyRangeFormGroup>;
  duplexModes: FormArray<DuplexModeFormGroup>;

  education: FormControl<boolean | null>;
  kubernetes: FormControl<boolean | null>;
  advancedMode: FormControl<boolean | null>;

  // Features
  flexRic: FormControl<boolean | null>;
  ueManagement: UeManagementFormGroup;
  networkSlicing: FormControl<boolean | null>;

  // Premium Features
  mobility: FormControl<boolean | null>;
  qosium: FormControl<boolean | null>;
  ris: FormControl<boolean | null>;
  multiRan: FormControl<boolean | null>;
  redCapConfiguration: RedCapConfigurationFormGroup;

  // Use Cases Library
  digitalTwin: FormControl<boolean | null>;
  isac: FormControl<boolean | null>;
  radarDetection: FormControl<boolean | null>;
  visionAidedCommunications: FormControl<boolean | null>;

  cn5gConfiguration: Cn5gConfigurationFormGroup;
}>;

export type FronthaulTypeFormGroup = FormGroup<{
  checked: FormControl<boolean>;
  type: FormControl<FronthaulType>;
}>;

export type FrequencyRangeFormGroup = FormGroup<{
  checked: FormControl<boolean>;
  type: FormControl<FrequencyRange>;
}>;

export type DuplexModeFormGroup = FormGroup<{
  checked: FormControl<boolean>;
  type: FormControl<DuplexMode>;
}>;

export function cn5gConfigurationValidator(
  control: AbstractControl
): ValidationErrors | null {
  const formGroup = control as Cn5gConfigurationFormGroup;
  const { cn5gRemote, cn5gIp, cn5gAmfIp, cn5gInterfaceName } =
    formGroup.controls;

  if (cn5gRemote.value) {
    if (!cn5gIp.value || !cn5gAmfIp.value || !cn5gInterfaceName.value) {
      return { cn5gConfigurationRequired: true };
    }
  }
  return null;
}
